module.exports = __webpack_public_path__ + "img/prox.026fa017.png";